import { store } from '../../../../redux/store';

export function getAuth() {
    const { Auth } = store.getState();
    return Auth;
}
